import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { Row, Col } from "react-bootstrap";

const DepartmentCategorySelect = ({
  value,
  isMulti,
  onChange,
  departmentCategories,
  department,
  label,
  name,
  isClearable
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (department) {
      const optionsToReturn = departmentCategories
        .filter((d) => d.department._id === department && d.status)
        .map((d) => ({
          label: d.name,
          value: d._id
        }))
        .sort((a, b) => {
          if (a.label > b.label) return 1;
          if (b.label > a.label) return -1;
          return 0;
        });
      setOptions(optionsToReturn);
    }
  }, [department, departmentCategories]);

  const handleChange = (selected) => {
    onChange(name, selected);
  };

  const getValue = (val) => {
    const originalValue = departmentCategories.find((cat) => cat._id === val);
    return originalValue
      ? { label: originalValue.name, value: originalValue._id }
      : null;
  };

  return (
    <Row className="form-group">
      <Col sm={12}>
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      </Col>
      <Col sm={12}>
        <Select
          id="service-select"
          className="react-select-container"
          classNamePrefix="react-select-container"
          fullwidth
          placeholder="Please Select..."
          value={getValue(value)}
          options={options}
          onChange={handleChange}
          isMulti={isMulti}
          isClearable={isClearable}
        />
      </Col>
    </Row>
  );
};

DepartmentCategorySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  departmentCategories: PropTypes.array,
  isMulti: PropTypes.bool,
  department: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  isClearable: PropTypes.bool
};
DepartmentCategorySelect.defaultProps = {
  departmentCategories: [],
  isMulti: false
};
export default DepartmentCategorySelect;
